import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Badge from 'react-bootstrap/Badge';
import noProduct from "../../common/images/no-product.png"
import { FaLongArrowAltRight } from "react-icons/fa";
import gsap from "gsap";

export const AlternativeDelivery = () => {

    React.useEffect(() => {
        gsap.fromTo('.Alternative-head', {
            x: -500, opacity: 0
        }, {
            x: 0, opacity: 1, scrollTrigger: {
                trigger: ".Alternative-head",
                start: "bottom 80%"
            }
        });

        gsap.fromTo('.Alternative-list-card', {
            y: 100, opacity: 0
        }, {
            y: 0, opacity: 1, stagger: { amount: 0.5 }, scrollTrigger: {
                trigger: ".Alternative-list-card",
                start: "Top 70%"
            }
        })
    }, [])

    return (
        <div className="section-content pb-100 main-bg">
            <Container>
                <div className="heading-container ps-sm-4 Alternative-head text-md-start mb-50">
                    <h2>Alternative Delivery System</h2>
                    <p>Your Choice</p>
                </div>
                <Row className="mx-0 g-2 g-md-5">
                    <Col xxl={3} lg={4} md={6}>
                        <div className="product-flip-card Alternative-list-card">
                            <div className="product-flip-card-inner">
                                <div className="product-flip-card-front">
                                    <div className='product-img'>
                                        <img src={noProduct} loading="lazy" className="w-100 h-100" alt="Product" />
                                    </div>
                                    <div className='product-name text-start'>
                                        <h3>Rapid Edibles</h3>
                                        <span className="btn text-white rounded-0 px-2 py-1 h3 hover-btn"><FaLongArrowAltRight /></span>
                                    </div>
                                </div>
                                <div className="product-flip-card-back">

                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xxl={3} lg={4} md={6}>
                        <div className="product-flip-card Alternative-list-card">
                            <div className="product-flip-card-inner">
                                <div className="product-flip-card-front">
                                    <div className='product-img'>
                                        <img src={noProduct} loading="lazy" className="w-100 h-100" alt="Product" />
                                    </div>
                                    <div className='product-name text-start'>
                                        <h3>Topicals</h3>
                                        <span className="btn text-white rounded-0 px-2 py-1 h3 hover-btn"><FaLongArrowAltRight /></span>
                                    </div>
                                </div>
                                <div className="product-flip-card-back">

                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xxl={3} lg={4} md={6}>
                        <div className="product-flip-card Alternative-list-card">
                            <div className="product-flip-card-inner">
                                <div className="product-flip-card-front">
                                    <div className='product-img'>
                                        <img src={noProduct} loading="lazy" className="w-100 h-100" alt="Product" />
                                    </div>
                                    <div className='product-name text-start'>
                                        <h3>Oils</h3>
                                        <span className="btn text-white rounded-0 px-2 py-1 h3 hover-btn"><FaLongArrowAltRight /></span>
                                    </div>
                                </div>
                                <div className="product-flip-card-back">

                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xxl={3} lg={4} md={6}>
                        <div className="product-flip-card Alternative-list-card">
                            <div className="product-flip-card-inner">
                                <div className="product-flip-card-front">
                                    <div className='product-img'>
                                        <img src={noProduct} loading="lazy" className="w-100 h-100" alt="Product" />
                                    </div>
                                    <div className='product-name text-start'>
                                        <h3>Capsule</h3>
                                        <span className="btn text-white rounded-0 px-2 py-1 h3 hover-btn"><FaLongArrowAltRight /></span>
                                    </div>
                                </div>
                                <div className="product-flip-card-back">

                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
